import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { loyaltyBonusEndpoint } from './loyalty.config';
import { LoyaltyBonusResponse } from './loyalty.types';

export type LoyaltyState = {
  loyaltyBonus?: LoyaltyBonusResponse;
};

const initialState: LoyaltyState = {};

const loyaltyBonusReducer = createReducer(initialState, (builder) => {
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;
    switch (payload.resourceId) {
      case loyaltyBonusEndpoint:
        state.loyaltyBonus = payload.response.data.response;
        return;
    }
  });
});

export default loyaltyBonusReducer;
